import { definePreset } from "@primeuix/themes"
import Aura from "@primeuix/themes/aura"

const SmartHomePreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: "#eef6fb",
      100: "#dcecf7",
      200: "#bddcf0",
      300: "#96c7e3",
      400: "#72b0d4",
      500: "#4f93c3",
      600: "#3f7ba6",
      700: "#356789",
      800: "#30566f",
      900: "#2e4a5c",
      950: "#1d303d",
    },
    colorScheme: {
      dark: {
        surface: {
          0: "#ffffff",
          50: "#ffffff",
          100: "#f7fafb",
          200: "#edf3f6",
          300: "#e1ebef",
          400: "#c8d5de",
          500: "#aab5bf",
          600: "#8c98a3",
          700: "#66727d",
          800: "#45515b",
          900: "#2e3942",
          950: "#1f2a33",
        },
        primary: {
          color: "#4f93c3",
          inverseColor: "#ffffff",
          hoverColor: "#3f7ba6",
          activeColor: "#356789",
        },
        highlight: {
          background: "rgba(79, 147, 195, 0.14)",
          focusBackground: "rgba(79, 147, 195, 0.24)",
          color: "#4f93c3",
          focusColor: "#4f93c3",
        },
      },
    },
  },
})

export { SmartHomePreset }
